import React, { useEffect, useContext, useState } from 'react'
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Container,
} from '@material-ui/core';


import UserAdminClientContext from "../contexts/UserAdminClientContext"

import Home from "../components/ui/AdminDashboard/Home"
import Suivi from "../components/ui/AdminDashboard/Suivi"
import Progression from "../components/ui/AdminDashboard/Progression"
import Certification from "../components/ui/AdminDashboard/Certification"

const AdminDashboard = () => {
  const navigate = useNavigate();

  const {
    actPage,
    actEcoleID,
    userLoaded,
  } = useContext(UserAdminClientContext)

  return (
    <>
      <Helmet>
        <title>Dashboard | TheLab</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.grey',
          minHeight: '100%',
          py: 0,
          display:"flex",
          flexDirection:"column",
        }}
      >

        {(userLoaded === true && actPage !== null && actEcoleID !== null) &&
          <>
            {actPage === "home" &&
              <Home />
            }
            {actPage === "suivi" &&
              <Suivi />
            }
            {actPage === "progression" &&
              <Progression />
            }
            {actPage === "certification" &&
              <Certification />
            }
          </>
        }


      </Box>
    </>
  )
};

export default AdminDashboard;
